export default "__VITE_ASSET__PUgHI_9c__"